import { render, staticRenderFns } from "./WebItem.vue?vue&type=template&id=232d299a&scoped=true"
import script from "./WebItem.vue?vue&type=script&lang=js"
export * from "./WebItem.vue?vue&type=script&lang=js"
import style0 from "./WebItem.vue?vue&type=style&index=0&id=232d299a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d299a",
  null
  
)

export default component.exports